<template>
  <div class="nettdoc-symptoms">
    <h2 class="nettdoc-symptoms__header">{{ $t('Symptoms') }}*</h2>

    <ul class="nettdoc-symptoms__list">
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.pain ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('pain', !store.symptoms.pain)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-pain.svg" alt="Pain" />
        <p>{{ $t('pain') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.breathingProblems ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('breathingProblems', !store.symptoms.breathingProblems)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-breath.svg" alt="breathing problems" />
        <p>{{ $t('breathingProblems') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.problemsOfDigestion ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('problemsOfDigestion', !store.symptoms.problemsOfDigestion)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-digestion.svg" alt="problems of digestion" />
        <p>{{ $t('problemsOfDigestion') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.raisedBodyTemperature ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('raisedBodyTemperature', !store.symptoms.raisedBodyTemperature)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-fever.svg" alt="raised body temperature" />
        <p>{{ $t('raisedBodyTemperature') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.dizziness ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('dizziness', !store.symptoms.dizziness)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-dizzy.svg" alt="dizziness" />
        <p>{{ $t('dizziness') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.weaknessOrExhaustion ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('weaknessOrExhaustion', !store.symptoms.weaknessOrExhaustion)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img
          src="../assets/illu-card-beschwerden-exhausting.svg"
          alt="weakness or exhaustion"
        />
        <p>{{ $t('weaknessOrExhaustion') }}</p>
      </li>

      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.rashItchRedness ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('rashItchRedness', !store.symptoms.rashItchRedness)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-rash.svg" alt="rash / itch / redness" />
        <p>{{ $t('rashItchRedness') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.paralysisDeafnessPrickle ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('paralysisDeafnessPrickle', !store.symptoms.paralysisDeafnessPrickle)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-paralysis.svg" alt="paralysis / deafness / prickle" />
        <p>{{ $t('paralysisDeafnessPrickle') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.sensoryPerception ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('sensoryPerception', !store.symptoms.sensoryPerception)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img
          src="../assets/illu-card-beschwerden-sensory-perception.svg"
          alt="sensory perception"
        />
        <p>{{ $t('sensoryPerception') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.gynecologicalIssues ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('gynecologicalIssues', !store.symptoms.gynecologicalIssues)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img
          src="../assets/illu-card-beschwerden-gynecological.svg"
          alt="gynecological issues"
        />
        <p>{{ $t('gynecologicalIssues') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.swelling ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('swelling', !store.symptoms.swelling)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-swelling.svg" alt="swelling" />
        <p>{{ $t('swelling') }}</p>
      </li>
      <li
        class="nettdoc-symptoms__list--item"
        :class="store.symptoms.childrensDisease ? 'nettdoc-active' : ''"
        @click="() => store.addSymptom('childrensDisease', !store.symptoms.childrensDisease)"
      >
        <div class="nettdoc-symptoms__list--item-background" />
        <img src="../assets/illu-card-beschwerden-children.svg" alt="childrens disease" />
        <p>{{ $t('childrensDisease') }}</p>
      </li>
    </ul>

    <div class="nettdoc-symptoms__additional-conditions">
      <h2 class="nettdoc-header">{{( $t('Additional conditions') )}}</h2>

      <SectionHeader text="sadness" img="sad" />
      <TripleChoice
        :model="store.additionalConditions.sadness"
        v-on:action="value => store.addAdditionalConditions('sadness', value)"
      />

      <SectionHeader text="panicAttacks" img="panic" />
      <TripleChoice
        :model="store.additionalConditions.panicAttacks"
        v-on:action="value => store.addAdditionalConditions('panicAttacks', value)"
      />

      <SectionHeader text="pregnancy" img="pregnant" />
      <TripleChoice
        :model="store.additionalConditions.pregnancy"
        v-on:action="value => store.addAdditionalConditions('pregnancy', value)"
      />

      <SectionHeader text="Are you taking any kind of medicine?" :required="true" />
      <YesNo
        infoText1="please show the medic the package"
        :model="store.additionalConditions.takingMedicine"
        v-on:action="value => store.addAdditionalConditions('takingMedicine', value)"
      />
    </div>

    <Button
      :text="edit ? 'Update' : 'Submit'"
      :active="store.symptomsComplete"
      v-on:action="submit"
    />
  </div>
</template>

<script>
import { observer } from "mobx-vue";
import store from "../store/store";
import YesNo from "../components/YesNo";
import TripleChoice from "../components/TripleChoice";
import Button from "../components/Button";
import SectionHeader from "../components/SectionHeader";
export default observer({
  name: "Symptoms",
  data() {
    return {
      store: store,
      submitActive: false
    };
  },
  props: {
    edit: Boolean
  },
  components: {
    YesNo,
    TripleChoice,
    Button,
    SectionHeader
  },
  created() {
    this.store.persistSymptoms()
    this.store.persistAdditionalConditions()
  },
  methods: {
    submit: function() {
      const symptoms = {};

      for (let symptom in this.store.symptoms) {
        const value = this.store.symptoms[symptom];
        if (value !== null) {
          symptoms[symptom] = value;
        }
      }

      const additionalConditions = {
        sadness: this.store.additionalConditions.sadness,
        panicAttacks: this.store.additionalConditions.panicAttacks,
        pregnancy: this.store.additionalConditions.pregnancy,
        takingMedicine: this.store.additionalConditions.takingMedicine
      }

      localStorage.setItem("symptoms", JSON.stringify(symptoms))
      localStorage.setItem(
        "additionalConditions",
        JSON.stringify(additionalConditions)
      )
      if (this.edit) {
        this.$emit('close')
      } else {
        this.$router.push(`/${this.$i18n.locale}/nettdoctor/symptomdetails`)
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.nettdoc-symptoms {
  position: absolute;
  width: 100%;
  background-color: #ffffff;
  text-align: center;
  &__header {
    text-align: left;
    margin: 0;
    padding: 30px 16px 41px 16px;
    font-size: 26px;
    font-weight: 500;
    color: var(--charcoal-grey);
  }
  &__list {
    box-sizing: border-box;
    list-style: none;
    padding: 0 16px;
    margin: 0;
    display: grid;
    grid-template-columns: 50% 50%;
    width: calc(100% - 20px);
    grid-gap: 20px;
    .nettdoc-active {
      background-color: var(--dark-peach);
      color: var(--white);
    }
    &--item {
      background-color: var(--pale-grey);
      box-sizing: border-box;
      border: 1px solid var(--light-sky-blue);
      padding-top: 10px;
      position: relative;
      cursor: pointer;
      img {
        width: 100%;
        max-width: 138px;
        position: relative;
        z-index: 1;
      }
      p {
        font-size: 12px;
        font-weight: bold;
      }
    }
    &--item-background {
      position: absolute;
      top: 10px;
      left: 10px;
      height: 94px;
      width: calc(100% - 20px);
      margin: auto;
      background-color: var(--white);
      z-index: 0;
      @media (max-width: 340px) {
        visibility: hidden;
      }    
    }
  }
  &__additional-conditions {
    margin-bottom: 31px;
    margin-top: 45px;
    h2 {
      margin: unset;
      font-size: 20px;
      font-weight: 600;
      text-align: left;
      padding: 0 16px 25px 16px;
    }
  }
}
</style>